<!-- Loading Skeleton -->
<div class="categories-skeleton" *ngIf="loading && items.length === 0">
  <div class="container">
    <div class="skeleton-header">
      <div class="skeleton-title"></div>
      <div class="skeleton-cart-icon"></div>
    </div>

    <div class="skeleton-search">
      <div class="skeleton-search-bar"></div>
    </div>

    <div class="skeleton-products">
      <div class="skeleton-product-grid">
        <div class="skeleton-product-item" *ngFor="let item of [1,2,3,4,5,6]">
          <div class="skeleton-product-image"></div>
          <div class="skeleton-product-name"></div>
          <div class="skeleton-product-price"></div>
          <div class="skeleton-product-button"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="categories-container" *ngIf="!loading || items.length > 0">
  <div class="container">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="header-info">
          <div class="category-badge">
            <i class="fas fa-utensils"></i>
            <span>Browse Menu</span>
          </div>
          <h2 class="category-name">{{category && capitalizeFirstLetter(category.name)}}</h2>
        </div>
        <div class="cart-section">
          <button class="cart-btn" (click)="cart(content2)" [disabled]="isCartLoading">
            <div class="cart-icon-wrapper">
              <i class="fas fa-shopping-cart" *ngIf="!isCartLoading"></i>
              <div class="cart-spinner" *ngIf="isCartLoading"></div>
              <span class="cart-count" *ngIf="cartItems.length > 0">{{ cartItems.length }}</span>
            </div>
            <span class="cart-text">Cart</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search Section -->
    <div class="search-section">
      <div class="search-card">
        <div class="search-header">
          <i class="fas fa-search search-icon"></i>
          <h3>Search in {{category?.name}}</h3>
        </div>
        <div class="search-wrapper">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="onSearch($event)"
            placeholder="Search products in {{category?.name}}"
            class="search-input" />
          <div class="search-actions">
            <button class="search-btn">
              <i class="fas fa-search"></i>
            </button>
            <button class="clear-btn" *ngIf="searchTerm" (click)="clearSearch()">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredItems.length === 0 && !loading">
      <div class="empty-state-card">
        <div class="empty-state-icon">
          <i class="fas fa-search" *ngIf="searchTerm"></i>
          <i class="fas fa-utensils" *ngIf="!searchTerm"></i>
        </div>
        <div class="empty-state-content">
          <h3 *ngIf="searchTerm; else noItemsTitle">No Results Found</h3>
          <ng-template #noItemsTitle>
            <h3>No Items Available</h3>
          </ng-template>

          <p *ngIf="searchTerm; else noItemsText">
            No results found for "<strong>{{searchTerm}}</strong>" in {{category?.name}}
          </p>
          <ng-template #noItemsText>
            <p>Sorry, no items are available in {{(category && category.name) || ''}} menu right now. Please explore other options or browse other categories.</p>
          </ng-template>

          <div class="empty-state-actions">
            <button class="clear-search-btn" *ngIf="searchTerm" (click)="clearSearch()">
              <i class="fas fa-times"></i>
              Clear Search
            </button>
            <a [routerLink]="['/home']" class="explore-btn">
              <i class="fas fa-compass"></i>
              Explore Other Categories
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Products Grid -->
    <div class="products-section" *ngIf="filteredItems.length > 0">
      <div class="products-header">
        <div class="section-info">
          <h3>Available Items</h3>
          <span class="items-count">{{filteredItems.length}} items found</span>
        </div>
      </div>

      <div class="products-grid">
        <div class="product-card"
             *ngFor="let item of filteredItems; trackBy: trackByItemId"
             [@fadeInUp]>
          <div class="product-image-wrapper">
            <img [src]="item.main_image"
                 [alt]="item.name"
                 class="product-image"
                 (error)="onImageError($event)">
            <div class="product-overlay" *ngIf="item.quantity <= 0">
              <span class="out-of-stock-badge">Out of Stock</span>
            </div>
          </div>

          <div class="product-info">
            <h4 class="product-name">{{ item.name }}</h4>
            <div class="product-price">
              <span class="price">{{ item.selling_price | currency: '₦' }}</span>
              <span class="price-unit">per unit</span>
            </div>
          </div>

          <div class="product-actions">
            <!-- If item is in cart, show increment/decrement buttons -->
            <div class="quantity-controls" *ngIf="item.inCart">
              <button class="quantity-btn decrement-btn"
                      [disabled]="item.userQuantity < 1"
                      (click)="decrement(item)">
                <i class="fas fa-minus"></i>
              </button>
              <div class="quantity-display">
                <span class="quantity-value">{{ item.userQuantity }}</span>
              </div>
              <button class="quantity-btn increment-btn"
                      (click)="increment(item)">
                <i class="fas fa-plus"></i>
              </button>
            </div>

            <!-- Add to Cart button if item is not in cart -->
            <div class="add-to-cart-section" *ngIf="!item.inCart">
              <button class="add-to-cart-btn"
                      *ngIf="item.quantity > 0"
                      [disabled]="noTable || isProductLoading"
                      (click)="addToCartModal(item, content3)">
                <i class="fas fa-plus" *ngIf="!isProductLoading"></i>
                <div class="btn-spinner" *ngIf="isProductLoading"></div>
                Add To Cart
              </button>
              <div class="out-of-stock-btn" *ngIf="item.quantity <= 0">
                <i class="fas fa-times-circle"></i>
                Out of Stock
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Load More Button -->
      <div class="load-more-section" *ngIf="page < totalPages">
        <button class="load-more-btn"
                [disabled]="loading"
                (click)="loadMoreItems()">
          <i class="fas fa-plus" *ngIf="!loading"></i>
          <div class="btn-spinner" *ngIf="loading"></div>
          Load More Items
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Remove Item Modal -->
<ng-template #content let-modal>
  <div class="custom-modal remove-item-modal">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-trash-alt"></i>
        <h3>Remove Item</h3>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.close('Cross click')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="item-preview">
        <div class="item-image">
          <img src="amala.png" alt="Amala">
        </div>
        <div class="item-info">
          <h4>Amala</h4>
          <p>Are you sure you want to remove this item from your cart?</p>
        </div>
      </div>

      <div class="modal-actions">
        <button class="action-btn remove-btn">
          <i class="fas fa-trash"></i>
          Remove Item
        </button>
        <button class="action-btn cancel-btn" (click)="modal.close('close click')">
          <i class="fas fa-times"></i>
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Cart Modal -->
<ng-template #content2 let-modal>
  <div class="custom-modal cart-modal">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-shopping-cart"></i>
        <h3>Your Cart</h3>
        <span class="cart-badge" *ngIf="cartItems.length > 0">{{cartItems.length}}</span>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.close('Cross click')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <app-create-cart></app-create-cart>
    </div>
  </div>
</ng-template>

<!-- Add to Cart Modal -->
<ng-template let-modal #content3>
  <div class="custom-modal add-to-cart-modal">
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-plus-circle"></i>
        <h3>Add to Cart</h3>
      </div>
      <button type="button" class="modal-close-btn" (click)="modal.dismiss('Cross click')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="product-details">
        <div class="product-info-section">
          <div class="product-text">
            <h4 class="product-title">{{ tempItem?.name }}</h4>
            <div class="product-pricing">
              <span class="price">{{ tempItem?.selling_price | currency: '₦'}}</span>
              <span class="price-unit">per unit</span>
            </div>
          </div>

          <div class="quantity-section">
            <div class="quantity-controls">
              <button class="quantity-btn decrement-btn"
                      [disabled]="tempItem?.userQuantity < 1"
                      (click)="decrement(tempItem)">
                <i class="fas fa-minus"></i>
              </button>
              <div class="quantity-display">
                <span class="quantity-value">{{ tempItem?.userQuantity || 0 }}</span>
              </div>
              <button class="quantity-btn increment-btn"
                      (click)="increment(tempItem)">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-divider"></div>

      <div class="modal-actions">
        <button class="action-btn continue-btn" (click)="modal.dismiss()">
          <i class="fas fa-arrow-left"></i>
          Continue Shopping
        </button>
        <button class="action-btn cart-btn-action" (click)="cart(content2)">
          <i class="fas fa-shopping-cart"></i>
          View Cart & Checkout
        </button>
      </div>
    </div>
  </div>
</ng-template>
